import { Box, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import ContactsDialog from "../../../components/ContactsDialog";
import { donate } from "../../../assets/links";
import DonateDialog from "../../../components/DonateDialog/DonateDialog";



const Contacts = () => {
    const { palette } = useTheme();
    const navigate = useNavigate();

    const [contactsOpen, setContactsOpen] = useState<boolean>(false);
    const [donateOpen, setDonateOpen] = useState<boolean>(false);

    return (
        <>
            <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", lg: "130px" } }}>
                <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px", lg: "36px" }} lineHeight="38px">
                    Контакти
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: { xs: "14px", lg: "30px" }, flexWrap: 'wrap' }}>
                    <Box
                        sx={{
                            background: palette.primary.dark,
                            width: { xs: "350px", md: "744px" },
                            height: "185px",
                            border: `1px solid ${palette.text.secondary}`,
                            borderRadius: "10px",
                            p: "24px 24px 24px 34px",
                            position: "relative",
                            cursor: "pointer",
                            mb: "18px",
                            display: { xs: "block", lg: "none" }
                        }}
                        onClick={() => setDonateOpen(true)}
                    >
                        <Typography variant="h3" fontFamily="Fixel Display, sans-serif" color="inherit" fontWeight="bold">
                            Підтримай нас тут
                        </Typography>
                        <Typography variant="h5" fontFamily="Fixel Display, sans-serif" color={palette.text.secondary} fontWeight="600">
                            Ваш внесок допоможе<br /> нам продовжувати нашу роботу.
                        </Typography>
                        <IconButton disableRipple size="large" sx={{ width: { xs: "24px", md: "28px" }, height: { xs: "24px", md: "28px" }, position: "absolute", right: "18px", bottom: "19px", border: `2px solid #fff`, p: "0px" }}>
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            background: palette.text.secondary,
                            width: { xs: "350px", md: "364px", lg: "375px" },
                            height: "185px",
                            borderRadius: "10px",
                            p: "24px 24px 24px 34px",
                            position: "relative",
                            cursor: "pointer",
                            mb: { xs: "18px", md: "0px" }
                        }}
                        onClick={() => setContactsOpen(true)}
                    >
                        <Typography variant="h3" fontFamily="Fixel Display, sans-serif" color="primary.dark" fontWeight="bold">
                            Знайди нас тут!
                        </Typography>
                        <Typography variant="h5" fontFamily="Fixel Display, sans-serif" color={palette.background.default} fontWeight="600" sx={{ mt: "7px" }}>
                            Підписуйтесь на наші сторінки в соцмережах, щоб слідкувати за нашою діяльністю та залишатися в курсі подій
                        </Typography>
                        <IconButton disableRipple size="large" sx={{ width: { xs: "24px", md: "28px" }, height: { xs: "24px", md: "28px" }, color: palette.background.default, position: "absolute", right: "18px", bottom: "19px", border: `2px solid ${palette.background.default}`, p: "0px" }}>
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            background: palette.primary.dark,
                            width: "540px",
                            height: "185px",
                            border: `1px solid ${palette.text.secondary}`,
                            borderRadius: "10px",
                            p: "24px 24px 24px 34px",
                            position: "relative",
                            cursor: "pointer",
                            display: { xs: "none", lg: "block" }
                        }}
                        onClick={() => setDonateOpen(true)}
                    >
                        <Typography variant="h3" fontFamily="Fixel Display, sans-serif" color="inherit" fontWeight="bold">
                            Підтримай нас тут
                        </Typography>
                        <Typography variant="h5" fontFamily="Fixel Display, sans-serif" color={palette.text.secondary} fontWeight="600">
                            Ваш внесок допоможе<br /> нам продовжувати нашу роботу.
                        </Typography>
                        <IconButton disableRipple size="large" sx={{ width: { xs: "24px", md: "28px" }, height: { xs: "24px", md: "28px" }, position: "absolute", right: "18px", bottom: "19px", border: `2px solid #fff`, p: "0px" }}>
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            background: palette.text.secondary,
                            width: { xs: "350px", md: "364px", lg: "375px" },
                            height: "185px",
                            borderRadius: "10px",
                            p: "24px 24px 24px 34px",
                            position: "relative",
                            cursor: "pointer"
                        }}
                        onClick={() => { navigate("/for-partners"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    >
                        <Typography variant="h3" fontFamily="Fixel Display, sans-serif" color="primary.dark" fontWeight="bold">
                            Давай співпрацювати!
                        </Typography>
                        <Typography variant="h5" fontFamily="Fixel Display, sans-serif" color={palette.background.default} fontWeight="600">
                            Ми відкриті до нових партнерств та колаборацій. Разом зможемо зробити більше для України!
                        </Typography>
                        <IconButton
                            disableRipple
                            size="large"
                            sx={{
                                width: { xs: "24px", md: "28px" }, height: { xs: "24px", md: "28px" },
                                color: palette.background.default,
                                position: "absolute",
                                right: "18px",
                                bottom: "19px",
                                border: `2px solid ${palette.background.default}`,
                                p: "0px"
                            }}
                        >
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit" }} />
                        </IconButton>
                    </Box>
                </Box>
            </Grid>
            <ContactsDialog open={contactsOpen} handleClose={() => setContactsOpen(false)} />
            <DonateDialog open={donateOpen} handleClose={() => setDonateOpen(false)} />
        </>
    )
}

export default Contacts